import { render, staticRenderFns } from "./CoordinateImageView.vue?vue&type=template&id=2ed7dee6&scoped=true&"
import script from "./CoordinateImageView.vue?vue&type=script&lang=js&"
export * from "./CoordinateImageView.vue?vue&type=script&lang=js&"
import style0 from "./CoordinateImageView.vue?vue&type=style&index=0&id=2ed7dee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed7dee6",
  null
  
)

export default component.exports